<template>
  <div>
    <Form
      ref="formValidate"
      :model="formValidate"
      :rules="ruleValidate"
      :label-width="100"
    >
    
    <FormItem label="语言" prop="language"> 
        <Select v-model="formValidate.language" clearable>
          <Option
            v-for="item in languages"
            :value="item.value"
            :key="item.value"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="模型" prop="model"> 
        <Select v-model="formValidate.model" clearable>
          <Option
            v-for="item in models"
            :value="item.value"
            :key="item.value"
            >{{ item.name}}</Option
          >
        </Select>
      </FormItem>

      <FormItem label="system" prop="system">
        <Input type="textarea" v-model="formValidate.system" placeholder="请填写"></Input>
      </FormItem>

      <template v-for="(item, index) in formValidate.messages">
        <FormItem :label="'message' + (index + 1)">
          <Row>
            <Col span="18">
            <Input type="textarea" v-model="item.value" placeholder="请填写"></Input>
            </Col>
            <Col span="4" offset="1">
            <Button @click="handleMessageRemove(index)">删除</Button>
            </Col>
          </Row>
        </FormItem>
      </template>

      <FormItem>
        <Row>
          <Col span="12">
          <Button type="dashed" long @click="handleMessageAdd" icon="md-add">添加message</Button>
          </Col>
        </Row>
      </FormItem>
      <FormItem style="text-align: right">
        <Button @click="handleReset('formValidate')">重置</Button>
        <Button
          type="primary"
          @click="handleSubmit('formValidate')"
          style="margin-left: 8px"
          >提交</Button
        >
      </FormItem>
    </Form>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

export default {
  components: { params },
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      classifyIds:[],
      show_path:'',
      loadding:false,
      videoSource:'',
      video_show:false,
      languages: [{ name: '中文', value: 'Chinese' }, { name: '印尼', value: 'Indonesia' }, { name: '英文', value: 'English' }],
      models: [{ name: 'gpt-4-turbo', value: 'gpt-4-turbo' }, { name: 'gpt-3.5-turbo', value: 'gpt-3.5-turbo' }],
      formValidate: {
        id: '',
        language:'',
        model:'',
        system:'',
        messages:[]
      },
      ruleValidate: {
        language: [
          {
            required: true,
            message: '必须选择语言',
            trigger: 'change'
          }
        ],model: [
          {
            required: true,
            message: '必须要选择模型',
            trigger: 'blur'
          }
        ],system: [
          {
            required: true,
            message: '必须填写system',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    resetFlag (resetFlag) {
      this.handleReset('formValidate')
    }
  },
  methods: {
    handleMessageAdd() {
      this.formValidate.messages.push({ "value": '' })
    },
    handleMessageRemove(index) {
      this.formValidate.messages.splice(index, 1)
    },
    handleSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.$emit('on-ok', this.formValidate)
        } else {
          this.$Message.error('失败!')
        }
      })
    },
    setEditData (editData) {
      this.formValidate.id = editData.id
      this.formValidate.language = editData.language
      this.formValidate.model = editData.model
      this.formValidate.system = editData.system

      if (editData.message){
        this.formValidate.messages = JSON.parse(editData.message)
      }

    },
    handleReset (name) {
      this.$refs[name].resetFields()
    }
    
  }
}
</script>
